import { motion } from "framer-motion";
import * as React from "react";

interface IProps {
    hide: boolean;
}

export const MprcHideEffectBlock = ({ hide, children }: IProps & React.PropsWithChildren) => {

    return (
        <motion.div
            variants={
                {
                    "show": {
                        transitionEnd: { display: "" }
                    },
                    hidden: {
                        opacity: 0, y: -25, transitionEnd: { display: "none" }
                    }
                }
            }
            animate={hide ? "hidden" : "show"}
            transition={{
                ease: [0.1, 0.25, 0.3, 1],
                duration: 0.5,
            }}
        >
            {children}
        </motion.div>
    );
};
